export enum TransactionType {
    all         = -1,
    matured     = -2,
    buy         = 0,
    reinvest    = 1,
    dividend    = 2,
    topup       = 3,
    adjust      = 4,
    interest    = 5,
}

export const TransactionTypeNames : Map<TransactionType,string> = new Map([
    [TransactionType.all,"All"],
    [TransactionType.matured,"Matured"],
    [TransactionType.buy, "Buy/Sell"],
    [TransactionType.reinvest, "Reinvest"],
    [TransactionType.dividend, "Dividend"],
    [TransactionType.topup, "Top-up"],
    [TransactionType.adjust, "Adjust"],
    [TransactionType.interest, "Interest"],
])

export const ValidTransactionTypes = new Set<number>([
    TransactionType.buy, TransactionType.reinvest, TransactionType.dividend,
    TransactionType.topup, TransactionType.adjust, TransactionType.interest
])

export const TransFields:Record<string,string> = {
    _id         :"_id",
    userId      :"u",
    ticker      :"i",
    type        :"t",
    date        :"d",
    quantity    :"q",
    account     :"a",
    price       :"p",
    note        :"n",
    yield       :"y",
    maturity    :"m",
}

export type TTransactionIdName = {id:TransactionType,name:string}
export const TransactionTypes : TTransactionIdName[] = Array.from(TransactionTypeNames.entries()).filter(([key]) => key>=0).map(([id,name]) => ({id,name}))

export interface ITransRow {
    _id:string;     // transaction id
    u:string;       // userId
    i:string;       // ticker
    t:number;       // type
    d:string;       // date
    q:number;       // qty
    a:number;       // account
    p:number;       // price
    n:string;       // note
    y:number;       // yield rate
    m:string;       // maturity
}

export type TTransaction = Omit<ITransRow, "u"|"i">
export type TTransaction_LessId = Omit<TTransaction, "_id">